var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ fullWidthLayout: _vm.$route.meta.fullWidthLayout }},[_c('public-status-page-nav-bar'),_c('div',{staticClass:"main-content",class:{
      loggedin: _vm.userLoggedIn
    },on:{"click":function($event){return _vm.$sidebar.displaySidebar(false)}}},[_c('fade-transition',{attrs:{"duration":200,"origin":"center top","mode":"out-in"}},[_c('router-view')],1)],1),_c('custom-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }